import classNames from "classnames/bind";
import ResponseVehicleAdCard from "common/blocks/VehicleAdCard/ResponseVehicleAdCard";
import { ResolvedVehicleCardSettings } from "resolvers/data/vehicleCardSettingsResolver";
import { ResolvedVehicleDisplaySettings } from "resolvers/pages/pdpPageResolver";
import { ResponseVehicle } from "services/motorpoint/shortlist";

import styles from "./GridView.module.scss";

const cx = classNames.bind(styles);

interface GridViewProps {
    title: string;
    vehicles: ResponseVehicle[];
    shortlistedStocks: number[];
    onClick: (vehicle: ResponseVehicle, index: number) => void;
    vehicleCardSettings: ResolvedVehicleCardSettings;
    vehicleDisplaySettings: ResolvedVehicleDisplaySettings;
}

const GridView: React.FC<GridViewProps> = ({
    title,
    shortlistedStocks,
    vehicles,
    onClick,
    vehicleCardSettings,
    vehicleDisplaySettings,
}) => {
    return (
        <>
            <div className={cx("row")}>{title && <h2 className={cx("title")}>{title}</h2>}</div>
            <div className={cx("row", "vehicles")}>
                {!!vehicles?.length &&
                    vehicles.map((vehicle, index) => (
                        <ResponseVehicleAdCard
                            {...vehicle}
                            className={cx("vehicleCard")}
                            key={vehicle.StockBookNumber}
                            isSaved={(shortlistedStocks ?? []).includes(vehicle?.StockBookNumber)}
                            onClick={() => onClick(vehicle, index)}
                            vehicleCardSettings={vehicleCardSettings}
                            vehicleDisplaySettings={vehicleDisplaySettings}
                        />
                    ))}
            </div>
        </>
    );
};

export default GridView;
